import { BaSeButton, BaSeContainer } from '@base/react';
import * as React from 'react';
import * as Styled from '../styled/breadcrumbs-styled';

interface PageBreadcrumbProps {
  title: string;
  backTo: string;
  badges?: React.ReactNode[];
  rightContent?: React.ReactNode;
}

const BreadcrumbsContainer: React.FC<PageBreadcrumbProps> = ({
  title,
  backTo,
  badges,
  rightContent,
}) => {
  return (
    <Styled.Content>
      <BaSeContainer delimitedOnBreakpoint="desktop">
        <Styled.Container>
          <Styled.Left>
            <BaSeButton
              value="Voltar"
              type="secondary"
              leftIcon="arrow-left"
              size="small"
              link={backTo}
            />
            <Styled.Title>{title}</Styled.Title>
          </Styled.Left>

          {badges && badges.length > 0 && (
            <>
              <Styled.Divider />
              <Styled.BadgeWrapper>
                {badges.map((badge, index) => (
                  <Styled.BadgeItem key={index}>{badge}</Styled.BadgeItem>
                ))}
              </Styled.BadgeWrapper>
            </>
          )}

          {rightContent && <Styled.Right>{rightContent}</Styled.Right>}
        </Styled.Container>
      </BaSeContainer>
    </Styled.Content>
  );
};

export { BreadcrumbsContainer };
